import { type PropsWithChildren, forwardRef } from 'react';

import styles from './FiltersLayout.css';

export const FiltersLayout = forwardRef<HTMLElement, PropsWithChildren>(function FiltersLayout({ children }, ref) {
  return (
    <section className={styles['filters-section']} ref={ref}>
      {children}
    </section>
  );
});
